import styled, { css } from 'styled-components';

export const CheckboxItem = styled.span`
  position: relative;
  display: inline-block;
  &.codelab {
    padding: 6px 4px;
    border-radius: 8px;
  }

  @media screen and (min-width: 769px) {
    &:hover {
      background-color: #f6f6f6;
    }
  }
`;

export const CheckboxInput = styled.input`
  opacity: 0;
  position: absolute;
  margin: 0;
  z-index: -1;
  width: 0;
  height: 0;
  overflow: hidden;
  left: 0;
  pointer-events: none;
  visibility: hidden;
  + label {
    &:before {
      display: ${(props) => (props.checked ? 'none' : 'inline-block')};
    }
    &:after {
      display: ${(props) => (props.checked ? 'inline-block' : 'none')};
    }
  }
`;

export const Label = styled.label`
  display: inline-block;
  height: ${(props) => (props.label ? 'auto' : '24px')};
  padding-left: ${(props) => (props.label ? '32px' : '24px')};
  font-size: 16px;
  cursor: pointer;
  color: #363636;
  font-family: 'SamsungOne-600';
  font-weight: 600;

  ${(props) =>
    props.label &&
    css`
      line-height: 24px;
    `}

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 3px;
    width: 24px;
    height: 24px;
    background-image: url(${`${process.env.PUBLIC_URL}/images/ico-checkbox.svg`});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    cursor: pointer;
  }

  &:after {
    display: none;
    content: '';
    position: absolute;
    top: 0;
    left: 3px;
    width: 24px;
    height: 24px;
    background-image: url(${`${process.env.PUBLIC_URL}/images/ico-checkbox-active.svg`});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    cursor: pointer;
  }
  ${(props) =>
    props.checked &&
    css`
      color: #2088fd;
    `}

  @media screen and (max-width: 768px) {
    font-family: 'SamsungOne-600';
    font-weight: 600;
  }
`;
